const IMAGE_WIDHT = 173;
const IMAGE_HEIGHT = 246;

const CONFIG = {
  IMAGE_WIDHT,
  IMAGE_HEIGHT,
} as const;

export default CONFIG;
